import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import { getDeviceDetails } from "../Actions/DeviceManagement";

class DeviceManagementCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
    };
  }
  render() {
    const { pageSize, totalRecords, currentPage, arraylist } = this.props;
    return (
      <div className="pb-3" style={{ marginTop: "12px" }}>
        {this.renderCardData()}
        {arraylist && arraylist.length ? (
          <div className="custom-paginator">
            <Paginator
              first={this.state.first}
              rows={pageSize}
              totalRecords={totalRecords}
              onPageChange={(e) => this.onPaginatorChange(e)}
            ></Paginator>
          </div>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !-- No Items to Display --!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div
            className="card mb-2"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div className="pl-4 pr-3 py-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className={"col-sm-11 col-md-11 col-11 m-auto"}>
                    <div className="row">
                      <div className={"col-sm-12 mb-2"}>
                        <h6 className="resource-list-title m-0">
                          ID : {item.id}
                        </h6>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-12 mb-1" : "col-sm-4 mb-1"
                        }
                      >
                        <span>
                          <strong>Make : </strong>
                          <span className="lato ">{item.make}</span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-12 mb-1" : "col-sm-4 mb-1"
                        }>
                        <span>
                          <strong>Model : </strong>
                          <span className="lato ">{item.model}</span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-12 mb-1" : "col-sm-4 mb-1"
                        }
                      >
                        <span>
                          <strong>Manufacturing Date : </strong>
                          <span className="lato ">
                            {moment(item.manufacturingDate).format(
                              "DD MMM YYYY"
                            )}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-12 mb-1" : "col-sm-4 mb-1"
                        }
                      >
                        <span>
                          <strong>Last Calibration Date : </strong>
                          <span className="lato ">
                            {moment(item.lastCalibrationDate).format(
                              "DD MMM YYYY"
                            )}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-12 mb-1" : "col-sm-4 mb-1"
                        }
                      >
                        <span>
                          <strong>Next Calibration Date : </strong>
                          <i aria-hidden="true"></i>
                          <span className="lato">
                            {moment(item.nextCalibrationDate).format(
                              "DD MMM YYYY"
                            )}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-12 mb-1" : "col-sm-4 mb-1"
                        }
                      >
                        <span>
                          <strong>Company Name : </strong>
                          <span className="lato ">{item.companyName}</span>
                        </span>
                      </div>
                      <div className={showSidePane ? "col-sm-12 mb-1" : "col-sm-4 mb-1"}>
                        <span>
                          <strong>Ship Name : </strong>
                          <span className="lato ">{item.shipName}</span>
                        </span>
                      </div>
                      <div className={showSidePane ? "col-sm-12 mb-1" : "col-sm-4 mb-1"}>
                        <span>
                          <strong>Maximum Limit : </strong>
                          <span className="lato ">{item.maximumLimit !== 0 ? item.maximumLimit : 0}</span>
                        </span>
                      </div>
                         <div className={showSidePane ? "col-sm-12 mb-1" : "col-sm-4 mb-1"}>
                        <span>
                          <strong>Is Active : </strong>
                          <span className="lato ">{item.isActive == true ? "Yes" : item.isActive == false ? "No" : "-"  }</span>
                        </span>
                      </div>
                      <div className={showSidePane ? "col-sm-12 mb-1" : "col-sm-8 mb-1"}>
                        <span>
                          <strong>Last Device Sync Date : </strong>
                          <span className="lato"> {item.lastSync ? moment.utc(item.lastSync).format("DD MMM YYYY k:mm " + " " + "UTC") : " - "}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      "col-sm-1 col-md-1 col-m-auto col-1 d-flex justify-content-end"}>
                    <div
                      className={
                        showSidePane ? "vertical-center" : "vertical-center"
                      }
                    >
                      <i
                        className="fa fa-eye fa-2x click"
                        onClick={() => this.eyeclick(item.deviceId)}
                        aria-hidden="true"
                        style={{ color: " #1a3464", marginLeft: "-15px" }}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };
  eyeclick = (id) => {
    const { dispatch } = this.props;
    dispatch({ type: "DeviceDetails", data: true });
    dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/Management/Device/${id}`);
    dispatch(getDeviceDetails(id));
    window.scrollTo(0, 0);
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DeviceManagementCard)
);
